/**
 * @file translations.ts
 * @module Translations
 * @description Internacionalizācijas (i18n) tulkojumu virknes latviešu (lv)
 *              un angļu (en) valodās. Satur visus UI nosaukumus, padomus un ziņojumus,
 *              ko izmanto visā Karšu pārlūka lietotnē (meklēšana, slāņi, iestatījumi u.c.).
 */

export const TRANSLATIONS = {
	lv: {
		translation: {
			timeFrom: "Laiks no",
			temporarilyUnavailable: "Īslaicīgi nav datu",
			warningType: "Brīdinājuma veids",
			warningFrom: "Brīdinājuma sākums",
			detourNotes: "Piezīmes",
			legend: "Apzīmējumi",
			search: "Meklēt vietu vai Koordinātas",
			data: "Slāņi",
			chooseLayers: "Izvēlēties slāņus...",
			searchLayers: "Meklēt datos un datu slāņos...",
			mapSettings: "Kartes iestatījumi",
			noData: "Nav",
			noDataHelperMsg: "Šobrīd nav aktuālu datu",
			sup20: "Reāllaika dati par pēdējām 20 minūtēm",
			sup60: "Reāllaika dati par pēdējām 60 minūtēm",
			lauWarning: "Uzmanību, ceļa uzturēšana",
			lauWarningGrader: "Veic ceļu uzturēšanu vai remontdarbus",
			lauWarningLorry: "Veic ceļa uzturēšanu",
			lauWarningCar: "Veic darbu zonas norobežošanu vai citus darbus",
			basemap: "Pamatkarte",
			otherSettings: "Citi iestatījumi",
			showLayerSource: "Rādīt datu slāņu avotus",
			baseOpacity: "Pamatkartes caurspīdīgums",
			showLegend: "Rādīt leģendu",
			save: "Saglabāt",
			showPanning: "Rādīt tuvināšānu iezīmējot",
			showLayerSets: "Rādīt slāņu komplektus",
			searchTooltipHelp: "Mēklēšana iespējama koordinātēs, piemēram, 56.94 24.10",
			panControl: "Tuvināt iezīmējot",
			addUnplanned: "Pievienot neplānotu notikumu",
			addPlanned: "Pievienot plānotu notikumu",
			addStatic: "Pievienot statisku objektu",
			attributions: "Datu avoti",
			dataSources: "Datu kopas",
			zoomIn: "Pietuvināt",
			zoomOut: "Attālināt",
			date: "Datums",
			outsideZoom: "Pietuviniet apskatei",
			layers: "Slāņi",
			pageTitle: '"Transports. Mobilitāte" | Latvijas Nacionālais piekļuves punkts - Satiksmes informācijas karte',
			dataLayers: "Datu slāņi",
			searchInLayers: "Meklēt slāņos",
			bubbleMessageNone: "Nav",
			bubbleMessageEvents: "Notikumu",
			bubbleMessageFew: "Maz",
			bubbleMessageEventsOpt: "Satiksmes notikumu",
			bubbleMessageMedium: "Vidējs",
			bubbleMessagesAmountOfEvents: "Satiksmes notikumu skaits",
			bubbleMessageMany: "Daudz",
			bubbleMessageEventsOpt2: "Satiksmes notikumu",
			true: "Jā",
			false: "Nē",
			returnToDefaultView: "Atgriezties uz Latvijas kopskatu",
			srtiTooltip: "Ar drošību saistīta satiksmes informācija",
			tipLabel: "Attiestatīt rotāciju",
			source: "Avoti",
			addPointTooltip: "Pievienot punktveida objektu",
			addLineTooltip: "Pievienot līnījveida objektu",
			addPolyTooltip: "Iezīmēt vietu līnījveida objektiem",
			addDetourTooltip: "Pievienot apvedceļu",
		},
	},
	en: {
		translation: {
			timeFrom: "Time from",
			temporarilyUnavailable: "Temporarily no data available",
			warningType: "Type of warning",
			warningFrom: "Start of the warning",
			detourNotes: "Notes",
			legend: "Legend",
			search: "Search for location or coordinates",
			data: "Layers",
			chooseLayers: "Choose layers...",
			searchLayers: "Search within data and data layers...",
			mapSettings: "Map settings",
			noDataHelperMsg: "No current data",
			sup20: "Real-time data for the last 20 minutes",
			sup60: "Real-time data for the last 60 minutes",
			lauWarning: "Warning, road maintenance",
			lauWarningGrader: "Performs winter or summer road maintenance or repair work",
			lauWarningLorry: "Performs winter or summer road maintenance",
			lauWarningCar: "Performs work zone delimitation or other tasks",
			basemap: "Basemap",
			otherSettings: "Other settings",
			showLayerSource: "Show layers' data sources",
			baseOpacity: "Basemap transparency",
			showLegend: "Show legend",
			save: "Save",
			showPanning: "Show drag zoom",
			showLayerSets: "Show layer sets",
			searchTooltipHelp: "The coordinate search format is 56.94 24.10",
			panControl: "Drag zoom",
			addUnplanned: "Add an unscheduled event",
			addPlanned: "Add a scheduled event",
			addStatic: "Add a static object",
			attributions: "Data sources",
			dataSources: "Data sets",
			zoomIn: "Zoom in",
			zoomOut: "Zoom out",
			date: "Date",
			outsideZoom: "Zoom in for viewing",
			layers: "Layers",
			pageTitle: '"Transport. Mobility" | Latvian National Access Point - Transport data map',
			dataLayers: "Data layers",
			searchInLayers: "Search within layers",
			bubbleMessageNone: "No",
			bubbleMessageEvents: "Events",
			bubbleMessageFew: "Few",
			bubbleMessageEventsOpt: "traffic events",
			bubbleMessageMedium: "Moderate",
			bubbleMessagesAmountOfEvents: "traffic events",
			bubbleMessageMany: "Many",
			bubbleMessageEventsOpt2: "traffic events",
			true: "Yes",
			false: "No",
			returnToDefaultView: "Return to Latvia's overview",
			srtiTooltip: "Safety-related traffic information",
			tipLabel: "Reset rotation",
			source: "Data sources",
			addPointTooltip: "Add point object",
			addLineTooltip: "Add line object",
			addPolyTooltip: "Draw area for line objects",
			addDetourTooltip: "Add detour",
		},
	},
};
